import { SLOTS_APIS } from "@/api_framework/api_config";
import { ILatestBookingResponse, ILatestBookingResponseData } from "@/api_framework/api_modals/Bookings";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useLatestBookingAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [latestBooking, setLatestBooking] = useState<ILatestBookingResponseData | null>(null);
  const [isLatestBookingInProgress, setIsLatestBookingInProgress] = useState(false);

  const execute = useCallback(
    async (userId: string, petId: string) => {
      if (!userId || !petId) {
        setLatestBooking(null);
        return null;
      }
      setIsLatestBookingInProgress(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(SLOTS_APIS?.LATEST_BOOKING?.baseURL ?? "", {
            params: {
              user_id: userId,
              pet_id: petId,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ILatestBookingResponse>) => {
            if (res.data.status === true) {
              const latestBookingData = Array.isArray(res.data.data) ? res.data.data?.[0] : res.data.data;
              setLatestBooking(latestBookingData);
              return latestBookingData;
            }
            setLatestBooking(null);
            return null;
          })
          .catch((e: AxiosError) => {
            if (e.config?.["curlCommand"]) {
              sendCurl(e.config["curlCommand"]);
            }
            setLatestBooking(null);
            return null;
          });
        return response;
      } catch (e: any) {
        setLatestBooking(null);
        toast.error("Server Error: " + e.message);
        return null;
      } finally {
        setIsLatestBookingInProgress(false);
      }
    },
    [configuration, sendCurl],
  );

  return { execute, latestBooking, isLatestBookingInProgress };
};
